import { cn } from "../../utils/classnames.js";
import { isThemeMode } from "../../utils/theme.js";
import { Button } from "../atoms/button.js";
import { useTheme } from "../../hooks/theme.js";
import { useCallback, useMemo } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
import { Loader, Monitor, Moon, Sun } from "lucide-react";
import { useLingui } from "@lingui/react";
import { UI_THEME_ICON_DARK_TESTID, UI_THEME_ICON_LIGHT_TESTID, UI_THEME_ICON_SYSTEM_TESTID, UI_THEME_TOGGLE_TESTID } from "@bitcart/qa";
//#region src/components/molecules/theme-toggle.tsx
const DEFAULT_THEME_MODE = "system";
const NEXT_THEME_MODE = {
	system: "light",
	light: "dark",
	dark: "system"
};
const ThemeToggle = ({ className, showLabel = false, testId = UI_THEME_TOGGLE_TESTID, triggerProps = {
	variant: "ghost",
	size: "icon"
} }) => {
	const { _: $__ } = useLingui();
	const { theme, setTheme } = useTheme();
	const themeMode = isThemeMode(theme) ? theme : DEFAULT_THEME_MODE;
	const toggleTheme = useCallback(() => setTheme(NEXT_THEME_MODE[themeMode]), [setTheme, themeMode]);
	const getThemeLabel = useCallback(() => {
		switch (themeMode) {
			case "light": return $__({
				id: "1njn7W",
				message: "Light"
			});
			case "dark": return $__({
				id: "pvnfJD",
				message: "Dark"
			});
			default: return $__({
				id: "D-NlUC",
				message: "System"
			});
		}
	}, [$__, themeMode]);
	const getButtonHint = useCallback(() => $__({
		id: "tWVq36",
		message: "Current theme: {0}. Click to cycle through themes.",
		values: { 0: getThemeLabel() }
	}), [getThemeLabel, $__]);
	const icon = useMemo(() => {
		const elementClassName = "text-foreground";
		switch (themeMode) {
			case "light": return /* @__PURE__ */ jsx(Sun, {
				className: elementClassName,
				"data-testid": UI_THEME_ICON_LIGHT_TESTID
			});
			case "dark": return /* @__PURE__ */ jsx(Moon, {
				className: elementClassName,
				"data-testid": UI_THEME_ICON_DARK_TESTID
			});
			default: return /* @__PURE__ */ jsx(Monitor, {
				className: elementClassName,
				"data-testid": UI_THEME_ICON_SYSTEM_TESTID
			});
		}
	}, [themeMode]);
	return /* @__PURE__ */ jsxs(Button, {
		onClick: toggleTheme,
		title: getButtonHint(),
		className,
		"aria-label": getButtonHint(),
		"data-testid": testId,
		...triggerProps,
		children: [icon, showLabel && /* @__PURE__ */ jsx("span", {
			className: "text-sm font-medium",
			children: getThemeLabel()
		})]
	});
};
const ThemeToggleFallback = ({ className }) => /* @__PURE__ */ jsx("span", {
	className: cn("size-9 flex items-center justify-center", className),
	children: /* @__PURE__ */ jsx(Loader, { className: "size-4 animate-spin text-foreground" })
});
//#endregion
export { ThemeToggle, ThemeToggleFallback };

//# sourceMappingURL=theme-toggle.js.map